"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@repo/components/atoms/shadcn/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@repo/components/atoms/shadcn/dropdown-menu";
import { Link } from "@repo/components/atoms/link";
import { readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { Customer_Fragment } from "#/graphql/shopify-storefront/fragments";
import { fetcherShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { useQuery } from "@tanstack/react-query";
import { getCookie } from "cookies-next/client";
import { type Usable } from "react";
import { SlUser } from "react-icons/sl";
import type { ResolvedIntlConfig } from "react-intl";
import { useAnalytics } from "use-analytics";
import { useGetIntl } from "@repo/i18n/intl/client";
import { useCustomerAccessTokenDeleteMutation } from "#/hooks/shopify";
import { AccountDropdown_Query } from "./graphql";
export function AccountDropdown(t0) {
  const $ = _c(80);
  const {
    className,
    dictionaryPromise,
    lang
  } = t0;
  let t1;
  if ($[0] !== dictionaryPromise || $[1] !== lang) {
    t1 = {
      dictionaryPromise,
      lang
    };
    $[0] = dictionaryPromise;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = useGetIntl(t1);
  const {
    track
  } = useAnalytics() || {};
  let t2;
  if ($[3] !== dictionaryPromise || $[4] !== lang) {
    t2 = {
      dictionaryPromise,
      lang
    };
    $[3] = dictionaryPromise;
    $[4] = lang;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    mutate: signOut
  } = useCustomerAccessTokenDeleteMutation(t2);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getCookie("customerAccessToken");
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const customerAccessToken = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      customerAccessToken: customerAccessToken ?? ""
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const variables = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [AccountDropdown_Query, variables];
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const queryKey = t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      enabled: Boolean(customerAccessToken),
      queryKey,
      queryFn: () => fetcherShopifyStorefront(AccountDropdown_Query, variables)
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const {
    data
  } = useQuery(t6);
  if (!customerAccessToken) {
    let t7;
    if ($[10] !== intl) {
      t7 = intl.formatMessage({
        defaultMessage: "Sign up or sign in to your account",
        description: "Prompt for the user to sign up or sign in to your account",
        id: "CfcBEd"
      });
      $[10] = intl;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    let t8;
    if ($[12] !== className) {
      t8 = <SlUser className={className} />;
      $[12] = className;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    let t9;
    if ($[14] !== t7 || $[15] !== t8) {
      t9 = <Link aria-label={t7} className="btn" href="/account" prefetch={false}>{t8}</Link>;
      $[14] = t7;
      $[15] = t8;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    return t9;
  }
  let t7;
  if ($[17] !== data) {
    t7 = data ?? {};
    $[17] = data;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const {
    customerMasked
  } = t7;
  let t8;
  if ($[19] !== customerMasked) {
    t8 = readFragmentShopifyStorefront(Customer_Fragment, customerMasked);
    $[19] = customerMasked;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const customer = t8;
  if (!customer) {
    let t9;
    if ($[21] !== intl) {
      t9 = intl.formatMessage({
        defaultMessage: "Go to your account page",
        id: "l5vrf4",
        description: "Text for an account link in the GlobalNavbarContent component"
      });
      $[21] = intl;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    let t10;
    if ($[23] !== className) {
      t10 = <SlUser className={className} />;
      $[23] = className;
      $[24] = t10;
    } else {
      t10 = $[24];
    }
    let t11;
    if ($[25] !== t10 || $[26] !== t9) {
      t11 = <Link aria-label={t9} className="flex items-center gap-2 whitespace-nowrap" href="/account" prefetch={false}>{t10}</Link>;
      $[25] = t10;
      $[26] = t9;
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    return t11;
  }
  let t9;
  if ($[28] !== track) {
    t9 = open => {
      if (track) {
        track("navbar_account_dropdown_menu_change", {
          open
        });
      }
    };
    $[28] = track;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <DropdownMenuTrigger className="btn"><SlUser className="icon fill icon-size" /></DropdownMenuTrigger>;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  const t11 = customer.displayName ?? customer.firstName;
  let t12;
  if ($[31] !== t11) {
    t12 = <p className="text-sm font-medium leading-none">{t11}</p>;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== customer.email) {
    t13 = <p className="text-muted-foreground text-xs leading-none">{customer.email}</p>;
    $[33] = customer.email;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t12 || $[36] !== t13) {
    t14 = <DropdownMenuLabel><div className="flex flex-col space-y-1">{t12}{t13}</div></DropdownMenuLabel>;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <DropdownMenuSeparator className="bg-gray-300 mx-2" />;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== intl) {
    t16 = intl.formatMessage({
      defaultMessage: "View or update your user profile",
      description: "aria-label attribute for a user profile navigation link in the GlobalNavbarContent component",
      id: "QSbX3n"
    });
    $[39] = intl;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== intl) {
    t17 = intl.formatMessage({
      defaultMessage: "View or update your user profile",
      description: "Text for a user profile navigation link in the GlobalNavbarContent component",
      id: "ufaW77"
    });
    $[41] = intl;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t16 || $[44] !== t17) {
    t18 = <DropdownMenuItem><Link className="flex items-center gap-2 whitespace-nowrap" href="/account/profile" aria-label={t16} prefetch={false}>{t17}</Link></DropdownMenuItem>;
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== intl) {
    t19 = intl.formatMessage({
      defaultMessage: "View or update your addresses",
      description: "aria-label attribute for an addresses navigation link in the GlobalNavbarContent component",
      id: "pBD6iR"
    });
    $[46] = intl;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== intl) {
    t20 = intl.formatMessage({
      defaultMessage: "View or update your addresses",
      id: "YYKrSW",
      description: "Text for an addresses navigation link in the GlobalNavbarContent component"
    });
    $[48] = intl;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t19 || $[51] !== t20) {
    t21 = <DropdownMenuItem><Link className="flex items-center gap-2 whitespace-nowrap" href="/account/addresses" aria-label={t19} prefetch={false}>{t20}</Link></DropdownMenuItem>;
    $[50] = t19;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== intl) {
    t22 = intl.formatMessage({
      defaultMessage: "View or update your orders",
      id: "LXSyaB",
      description: "aria-label attribute for an orders navigation link in the GlobalNavbarContent component"
    });
    $[53] = intl;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== intl) {
    t23 = intl.formatMessage({
      defaultMessage: "View or update your orders",
      id: "D96s1j",
      description: "Text for an orders navigation link in the GlobalNavbarContent component"
    });
    $[55] = intl;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== t22 || $[58] !== t23) {
    t24 = <DropdownMenuItem><Link className="flex items-center gap-2 whitespace-nowrap" href="/account/orders" aria-label={t22} prefetch={false}>{t23}</Link></DropdownMenuItem>;
    $[57] = t22;
    $[58] = t23;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <DropdownMenuSeparator className="bg-gray-300 mx-2" />;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== intl) {
    t26 = intl.formatMessage({
      defaultMessage: "Sign out",
      id: "SBDvE5",
      description: "Text for a sign out action button in the GlobalNavbarContent component"
    });
    $[61] = intl;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== signOut) {
    t27 = () => {
      if (customerAccessToken) {
        signOut({
          customerAccessToken
        });
      }
    };
    $[63] = signOut;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== intl) {
    t28 = intl.formatMessage({
      defaultMessage: "Sign out",
      id: "SBDvE5",
      description: "Text for a sign out action button in the GlobalNavbarContent component"
    });
    $[65] = intl;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== t26 || $[68] !== t27 || $[69] !== t28) {
    t29 = <DropdownMenuItem><Button aria-label={t26} className="hover:no-underline" onClick={t27} variant="link">{t28}</Button></DropdownMenuItem>;
    $[67] = t26;
    $[68] = t27;
    $[69] = t28;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  let t30;
  if ($[71] !== t14 || $[72] !== t18 || $[73] !== t21 || $[74] !== t24 || $[75] !== t29) {
    t30 = <DropdownMenuContent collisionPadding={32} sideOffset={16} className="sm:bg-background rounded-none border-none p-4">{t14}{t15}{t18}{t21}{t24}{t25}{t29}</DropdownMenuContent>;
    $[71] = t14;
    $[72] = t18;
    $[73] = t21;
    $[74] = t24;
    $[75] = t29;
    $[76] = t30;
  } else {
    t30 = $[76];
  }
  let t31;
  if ($[77] !== t30 || $[78] !== t9) {
    t31 = <DropdownMenu onOpenChange={t9}>{t10}{t30}</DropdownMenu>;
    $[77] = t30;
    $[78] = t9;
    $[79] = t31;
  } else {
    t31 = $[79];
  }
  return t31;
}